import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import StatLineGauge from 'app/components/Gauges/StatLineGauge';
import BlockGradTemplate from 'app/components/DesignVersion/Grad/Blocks/BlockGradTemplate';
import { isDefined } from 'app/utils/types';
import { getVideogameKey } from 'app/i18n/utils';

import { getTeamStatsLines } from './utils';
import style from './style.module.scss';

interface Props {
  data: TeamsStatsBlockMatch;
}

const TeamsStatsBlockGrad: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  const statsLines = getTeamStatsLines(data);

  return (
    <BlockGradTemplate hasData={statsLines.length > 0}>
      <StatLineGauge
        lines={statsLines}
        translationKey={`block-teams_stats-videogame_${getVideogameKey(data.videogame_slug)}`}
        forceGaugesDisplay
        joined
      />
      <div className={style.teamsStatsSamples}>
        <div className={style.team1StatsSample}>
          {isDefined(data.opponents.at(0)?.number_of_games) && (
            <>
              <div className={style.teamStatsGaugeColor} />
              <div>
                {t('block-teams_stats-based_on', {
                  numberOfGames: data.opponents.at(0)?.number_of_games
                })}
              </div>
            </>
          )}
        </div>
        <div className={style.team2StatsSample}>
          {isDefined(data.opponents.at(1)?.number_of_games) && (
            <>
              <div className={style.teamStatsGaugeColor} />
              <div>
                {t('block-teams_stats-based_on', {
                  numberOfGames: data.opponents.at(1)?.number_of_games
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </BlockGradTemplate>
  );
};

TeamsStatsBlockGrad.displayName = 'TeamsStatsBlockGrad';

export default TeamsStatsBlockGrad;
